import styled from '@emotion/styled';
import { helperTypographyTitle, TypographyTitleProps } from '../../../helpers';

export const TitleEmotion = styled('h1')<TypographyTitleProps>`
  ${props => helperTypographyTitle(props)};
`;
